module.exports = __webpack_public_path__ + "static-portal/img/stbq.d88422f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stbq.jpg
// module id = XkYB
// module chunks = 4